import DetailsPanelEdit from './DetailsPanelEdit';

export default DetailsPanelEdit;
